/** state **/
import axios from 'axios';
import {KRBS_TONS, APP_TONS} from '../../config/constanst.config';
import {AlertService} from '../../service/alert.service';
import SecureLs from 'secure-ls';
import CryptoJs from 'crypto-js';
import Staff from '../../views/dashboard/staff';

const state = {
  user : {},
  users: [],
  formUserData : {
    searchVal: null,
    count: 10,
    page: 1,
  },
};

/** mutations **/
const mutations = {
  //region set mutations
  set_user(state,payload){
    state.user = {
      assignedVessels: payload?.assignedVessels,
      siName : payload?.siName,
    }
  },

  set_assigned_vessels(state,payload){
    state.user.assignedVessels = payload
  },

  set_users(state,payload){
    state.users = payload
  },

  //todo delete assigned vessel
  set_delete_assigned_vessel(state,payload){
    payload.forEach(function(val){
      let indexVessels = state.user.assignedVessels.findIndex((v,k) => v.id === val);
      state.user.assignedVessels.splice(indexVessels,1)
    })
  },
  //endregion

  //region reset mutations
  reset_user(state,payload){
    state.user = {}
  },

  reset_users(state,payload){
    state.users = payload
  },

  reset_form_user_data(state){
    state.formUserData = {
      searchVal: null,
      count: 10,
      page: 1,
    }
  },

  reset_assigned_vessels(state){
    state.assignedVessels = []
  }
  //endregion
};

/** actions **/
const actions = {
  async set_user_paginated({commit},payload) {
    commit('set_is_loading',true)
    return await axios.post(KRBS_TONS.STAFF_GET_USER_PAGINATED,payload).then((r) => {
      commit('set_is_loading',false)
      commit('set_user_pagination',r.data)
      commit('set_users',r.data.data)
      return true;
    }).catch((error) =>{
      // console.log(error)
      AlertService.responseAlertMessage(error,'Get user paginated')
      return false;
    });
  },

  async getAssignedVessels({commit},payload){
    commit('set_is_loading',true)
    return await axios.get(`${KRBS_TONS.STAFF_GET_USER_VESSELS}/${payload}`).then((r)=>{
      commit('set_is_loading',false)
      commit('set_user',r.data)
      commit('set_vessel_keys',r.data.vesselKeys)
      return true;

    }).catch((er)=>{
      commit('set_is_loading',false)
      AlertService.responseAlertMessage(er,'Get assigned vessels')
      return false;
    });
  },

  addAssignedVessels({commit},payload){
    return axios.post(`${KRBS_TONS.STAFF_ADD_USER_VESSELS}/${payload.userId}`,payload.vessels).then((r)=>{
      commit('set_assigned_vessels',r.data)
      AlertService.successAlertService('Successfully added vessel','Assigned vessels')
      return true;

    }).catch((er)=>{
      AlertService.responseAlertMessage(er,'Add assigned vessels')
      return false;

    })
  },

  deleteAssignedVessels({commit},payload){
    return axios.post(`${KRBS_TONS.STAFF_DEL_USER_VESSELS}/${payload.userId}`,payload.vesselsId).then((r)=>{
      commit('set_delete_assigned_vessel',r.data)
      return true;
    }).catch((er)=>{
      AlertService.responseAlertMessage(er,'Delete assigned vessels')
      return false;
    })
  },

  reset_user({commit},payload){
    commit('reset_user')
  },

  reset_users({commit}, payload) {
    commit('reset_users')
  },

  reset_form_user_data({commit}) {
    commit('reset_form_user_data')
  },

  async addSIUser({commit}, payload) {
    return axios.post(KRBS_TONS.USER_CUD, payload).then((r)=>{
      AlertService.successAlertService('Successfully added SI user','Create User')
      return true;
    }).catch((er)=>{
      AlertService.responseAlertMessage(er,'Add SI User')
      return false;
    })
  },

  async deleteSIUser({commit}, payload) {
    return axios.delete(`${KRBS_TONS.USER_CUD}/${payload}`).then((r)=>{
      AlertService.successAlertService('Successfully deleted SI user','Delete User')
      return true;
    }).catch((er)=>{
      AlertService.responseAlertMessage(er,'Delete SI User')
      return false;
    })
  },

  async updateSIUser({commit}, payload) {
    return axios.put(`${KRBS_TONS.USER_CUD}/${payload.id}`, payload).then((r)=>{
      AlertService.successAlertService('Successfully updated SI user','Update User')
      return true;
    }).catch((er)=>{
      AlertService.responseAlertMessage(er,'Update SI User')
      return false;
    })
  },

};

/** getters **/
const getters = {
  user : state => state.user,
  users : state => state.users,
  formUserData : state => state.formUserData,
};

/** export **/
export default {state, actions, mutations, getters};
